import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import Layout from '../../Utils/Navbar/navbar-layout-component';
import Footer from '../../Utils/Footer/footer-component';
import Contact from '../Contact-screen/Contact';
import OurWorkSection from '../../Utils/Sections/section-our-work-component';

import { getOurWorkData } from '../../Public/our-work-data';
import QuickCallSection from '../../Utils/Sections/section-quick-call-component';

function OurWorkScreen() {
    // 1. Get current language from Redux to fetch the correct localized SEO data
    const systemData = useSelector((s) => s.systemData || {});
    const { language } = systemData;

    // 2. Scroll to top on mount
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // 3. Fetch localized data
    const ourWorkData = getOurWorkData(language);

    return (
        <div className="bg-white dark:bg-black min-h-screen flex flex-col">
            {/* Layout handles the SEO injection */}
            <Layout seo={ourWorkData?.seo}>

                <main className="flex-grow">
                    {/* Gallery & Specials */}
                    <OurWorkSection isMisionaryImage={false} />

                    {/* <QuickCallSection /> */}

                    {/* Contact Section at the bottom */}
                    <Contact />
                </main>

            </Layout>
            <Footer />
        </div>
    );
}

export default OurWorkScreen;